import { render, staticRenderFns } from "./GFormGroup.vue?vue&type=template&id=73e90ca1&"
import script from "./GFormGroup.vue?vue&type=script&lang=js&"
export * from "./GFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports